import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { CountriesService } from 'src/app/countries/countries.service';
import { UsersService } from 'src/app/users/users.service';
import { OrganizationsService } from '../organizations.service';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-organizations-detail',
  templateUrl: './organizations-detail.component.html',
  styleUrls: ['./organizations-detail.component.scss']
})
export class OrganizationsDetailComponent implements OnInit {
  public organization: any = {};
  public countries: any[];
  public responsibles: any[];
  

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private organizationsService: OrganizationsService,
    private countriesService: CountriesService,
    private messageService: MessageService,
    private usersService: UsersService,
    private coreDialogService: CoreDialogService,
    private config: DynamicDialogConfig
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {      
      this.loadData(params['id']);
    });
  }

  loadData(id: number) {
    this.loadCountries();
    this.loadResponsibles();
    if (id != 0) {
      this.organizationsService.get(id).subscribe(
        data => {
          this.organization = data;
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  loadCountries() {
    this.countriesService.all({}).subscribe(
      data => {
        this.countries = data.rows;
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  loadResponsibles() {
    this.usersService.all({}).subscribe(
      data => {
        this.responsibles = data.rows;
        this.responsibles.unshift({name : 'Ninguno', id: null});
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  cancel() {
    this.router.navigate(["/organizations", this.organization.id]);
  }

  save() {
    if (this.organization.email != null) this.organization.email = this.organization.email.trim();
    if (this.organization.email != null && this.organization.email.length > 0 && !this.validateEmail(this.organization.email)) {
      this.messageService.add({closable: false, severity: "error", detail: "Debes introducir un email válido."});
      return;
    }
    if(this.organization.vat_country_id == null) this.organization.vatCountry = null;
    if(this.organization.organization_type_id == null) this.organization.organizationType = null;
    if (this.organization.country_id == null) this.organization.country = null;
    if (this.organization.origin_id == null) this.organization.origin = null;
    if (this.organization.sector_id == null) this.organization.sector = null;
    if (this.organization.responsible_2_id == null) this.organization.responsible_2 = null;

    if (typeof this.organization.id === "undefined") {
      this.organizationsService.add(this.organization).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: 'success', summary: "Organización añadida correctamente." });
          this.router.navigate(['/organizations']);
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      );
    } else {
      this.organizationsService.save(this.organization.id, this.organization).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: "success", detail: "Organización guardada correctamente" });
          this.router.navigate(["/organizations"]);
        },
        error => {
          console.log(error);
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      );
    }    
  }

  delete() {
    this.coreDialogService.confirm({
      message:"¿Quieres borrar el rol " +this.organization.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept:()=>{
        this.organizationsService.delete(this.organization.id).subscribe(
          data => {
            this.messageService.add({closable: false, severity: 'success', detail: "Borrado correctamente"});
            this.router.navigate(['/organizations']);
          },
          error => {
            this.messageService.add({closable: false, severity:'error', detail:error.error.title});
          }
        )
      },
      reject:()=>{}
    })
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
}
